export const CONFIRM_DIALOG_DEFAULT_VALUE = { confirmed: false };
